'use client';

import React from 'react';
import BodyWidth from '../BodyWidth';
import Footer from '@/components/footer';
import { getMainMargin } from '@/utils/common-utils';

const Layout = (props: {
  children: React.ReactNode;
  needViewPort?: boolean;
}) => {
  const { children, needViewPort = false } = props;
  const [mainMargin, setMainMargin] = React.useState('0px');
  const mainRef = React.useRef<HTMLDivElement>(null);
  const [footerMargin, setFooterMargin] = React.useState('0px');

  React.useEffect(() => {
    const margin = getMainMargin(mainRef);
    setMainMargin(margin);
  }, []);

  return (
    <>
      <BodyWidth needViewPort={needViewPort} />
      <main
        className="flex"
        style={{
          marginTop: mainMargin,
          minHeight: `calc(100vh - ${mainMargin} - ${footerMargin})`,
        }}
        ref={mainRef}
      >
        {children}
      </main>
      <Footer setFooterMargin={setFooterMargin} />
    </>
  );
};

export default Layout;
